import { cn } from "../../util";
import { HEADLINE_CLASS_BY_LEVEL, type HeadlineLevel } from "./constants";

export type Props = {
  children: React.ReactNode;
  className?: string;
  level?: HeadlineLevel;
};

export default function Headline({ children, className, level = 1 }: Props) {
  return (
    <div
      aria-level={level}
      className={cn(
        `font-roboto ${level === 4 ? "" : "font-semibold"} leading-normal text-neutral-black`,

        HEADLINE_CLASS_BY_LEVEL[level],
        className,
      )}
      role="heading"
    >
      {children}
    </div>
  );
}
